import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/AuthProvider';

function MyAccountNav({activeLink}) {
    const auth = useAuth();
    const navigate = useNavigate();

    const handleLogout=()=>{
        auth.logOut();
    }

    return (
        <>
            <ul className="my-account-nav">
                <li><Link to="/my-account" className={`my-account-nav-item ${activeLink ==="dashboard"?"active":""}`}>Dashboard</Link></li>
                <li><Link to="/my-account-orders" className={`my-account-nav-item ${activeLink ==="orders"?"active":""}`}>Orders</Link></li>
                <li><Link to="/my-account-address" className={`my-account-nav-item ${activeLink ==="address"?"active":""}`}>Addresses</Link></li>
                <li><Link to="/my-account-edit" className={`my-account-nav-item ${activeLink ==="details"?"active":""}`}>Account Details</Link></li>
                {/* <li><Link to="/my-account-wishlist" className="my-account-nav-item">Wishlist</Link></li> */}
                <li><Link to="/login" onClick={handleLogout} className="my-account-nav-item">Logout</Link></li>
            </ul>
        </>
    )
}

export default MyAccountNav